const formatter = new Intl.ListFormat('pt-BR')

const toList = (value: string[]) => {
  return formatter.format(value)
}

export { toList }
